// src/firebase.js
import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'
import { getStorage } from 'firebase/storage'


// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAhXIaE7bUs6ScRyEVooe76jF3hd0TJfZ8",
  authDomain: "communities-evoosurvey.firebaseapp.com",
  projectId: "communities-evoosurvey",
  storageBucket: "communities-evoosurvey.firebasestorage.app",
  messagingSenderId: "1095246197562",
  appId: "1:1095246197562:web:638fac7a475f1cab6f1603"
};


const app = initializeApp(firebaseConfig)

export const auth = getAuth(app)
export const db = getFirestore(app)
export const storage = getStorage(app) // <-- Storage referansı